import React from 'react';
import { AccountInfo } from '@azure/msal-browser';
import { Avatar, Icon, ListItem, ListItemAvatar, ListItemText, styled } from '@mui/material';

const StyledAvatar = styled(Avatar)(({ theme }) => ({
	margin: theme.spacing(0.5),
	fontSize: '14px'
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	width: '100%'
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: theme.spacing(0.5),
	backgroundColor: theme.palette.background.default,
	'&:hover': {
		backgroundColor: theme.palette.background.default,
		opacity: 0.7,
		cursor: 'pointer'
	}
}));

export const UserAccount = (props: { account: AccountInfo; current?: boolean; showCurrent?: boolean; onClick?: (account: AccountInfo) => void }) => {
	const { account, current, showCurrent, onClick } = props;
	const avatarUserName = account?.username ? encodeURIComponent(account.username) : '';

	function handleClick() {
		if (onClick) {
			onClick(account);
		}
	}

	return (
		<StyledListItem onClick={handleClick}>
			<ListItemAvatar>
				<StyledAvatar alt='Profile Avatar' src={`/api/avatar/${avatarUserName}`}>
					<Icon>person</Icon>
				</StyledAvatar>
			</ListItemAvatar>
			<StyledListItemText
				primary={`${account ? account.name : ''}${current && showCurrent ? ' (current)' : ''}`}
				secondary={account ? account.username : ''}
				primaryTypographyProps={{ fontSize: 13 }}
				secondaryTypographyProps={{ fontSize: 11 }}
			/>
		</StyledListItem>
	);
};
